import styled, { css } from 'styled-components';

import { Colors, Shadows } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const MenuHeader = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  align-items: center;
  padding: 0 12px;
  margin: 0 12px;
  box-sizing: border-box;
  min-height: ${(props) => props.theme.layout.headerHeight}px;
  border-bottom: 1px solid ${ct({ Dark: Colors.DarkerMiddle, Light: Colors.DarkerMiddle })};

  &[aria-expanded='false'] {
    flex-direction: column;
    gap: 16px;
    justify-content: center;
  }
`;

export const MenuContent = styled.div`
  flex: 1 1 0.01px;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const MenuSectionWrapper = styled.div<{ $isCollapsed: boolean }>`
  margin-bottom: 30px;

  ${(props) =>
    props.$isCollapsed &&
    css`
      margin-bottom: 24px;
    `}
`;

export const MenuStyled = styled.div`
  display: flex;
  flex-flow: column;
  width: ${(props) => props.theme.layout.mainCollapsedMenuWidth}px;
  height: 100vh;
  box-shadow: ${ct({ Dark: Shadows.DialogDarkMode, Light: Shadows.DialogLightMode })};
  background: ${ct({ Dark: Colors.Darkest, Light: Colors.Darkest })};
  overflow: hidden;
  z-index: 45;

  transition: width ease-in-out 0.3s;

  &[data-is-full-menu-visible='true'] {
    width: ${(props) => props.theme.layout.mainFullMenuWidth}px;
    box-shadow: none;
  }

  &[data-is-category-dashboard-visible='true'] {
    border-right: 1px solid ${ct({ Dark: Colors.DarkerMiddle, Light: Colors.DarkerMiddle })};
  }
`;

export const MenuBottomContainer = styled.div`
  padding: 0 16px;
`;

export const MenuBottomInnerContainer = styled.div<{ $isCollapsed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${ct({ Dark: Colors.DarkerMiddle, Light: Colors.DarkerMiddle })};
  padding: 16px 0;
  transition: ease-in-out 0.3s;

  ${(props) =>
    props.$isCollapsed &&
    css`
      flex-direction: column;
      border: none;
    `}
`;

export const MenuBottomCollapsedSeparator = styled.div<{ $isCollapsed: boolean }>`
  display: none;

  ${(props) =>
    props.$isCollapsed &&
    css`
      display: block;
      height: 1px;
      width: 100%;
      background: ${ct({ Dark: Colors.DarkerMiddle, Light: Colors.DarkerMiddle })};
      margin: 16px 0;
    `}
`;
